export default __webpack_public_path__ + "static/media/susie3.a3ea781c.jpg";